import ConcurrentEditingBanner from 'components/forms/ConcurrentEditingBanner';
import { useResourceEditingSession } from 'hooks/useResourceEditingSession';
import { EditableResourceType } from 'store/api/editingSession';
import useEditableResourceFromRoute from './useEditableResourceFromRoute';

interface ActiveSessionProps {
    resourceType: EditableResourceType;
    resourceId: string;
    messageId: string;
}

const ActiveSession = ({ resourceType, resourceId, messageId }: ActiveSessionProps) => {
    const { otherEditors } = useResourceEditingSession({ resourceType, resourceId });

    if (otherEditors.length === 0) {
        return null;
    }

    return <ConcurrentEditingBanner editors={otherEditors} messageId={messageId} />;
};

const ConcurrentEditingIndicatorBar = () => {
    const resource = useEditableResourceFromRoute();

    if (!resource) {
        return null;
    }

    return (
        <ActiveSession
            resourceType={resource.resourceType}
            resourceId={resource.resourceId}
            messageId={resource.messageId}
        />
    );
};

export default ConcurrentEditingIndicatorBar;
